export default ({ toggleVideoModal }: { toggleVideoModal: () => void }) => {
  toggleVideoModal();
};
